export default (axios, baseURL) => async (displayName) => {
  const url = `/hub/hub-tenants/${encodeURIComponent(displayName)}/hub-config`;

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
